<template>
  <Modal
    :width="width"
    title="选择落地页"
    class-name="vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="!show"></Spin>
    <div class="account-box" v-if="showAccount">
      <div
        class="account-item"
        v-for="item in accounts"
        :key="item.id"
        :class="{ 'active-account': item.id === account }"
        @click="selectAccount(item)"
      >
        <span>{{ item.name }}</span>
        <span class="selected" v-if="accountSelected(item)">（已选）</span>
      </div>
    </div>
    <div class="data-table" :class="{ 'width-full': !showAccount }">
      <Input
        v-model.trim="search"
        placeholder="请输入落地页名称或者ID"
        class="input"
        search
        enter-button
        @on-search="handleSearch"
        v-if="filter"
      ></Input>
      <Table
        ref="pageSelectTable"
        height="440"
        stripe
        highlight-row
        :columns="columns"
        :data="linkDataList"
        :row-class-name="rowClassName"
        @on-current-change="bindCurrentRow"
      ></Table>
    </div>
    <Page
      v-if="total"
      class="page-index"
      show-total
      :current.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      @on-change="changePageIndex"
    />
    <div slot="footer">
      <Button type="text" size="large" @click="$emit('on-close')">取消</Button>
      <Button type="primary" size="large" @click="asyncSelect">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { siteGetList, getAssetList } from '@/api/toutiao.model'
import { getMagneticPage } from '@/api/kuaishou.model'
import { getCaoHuaLinks } from '@/api/common.model'
export default {
  name: 'PageData',
  props: {
    value: {
      type: Boolean
    },
    accounts: {
      type: Array
    },
    showAccount: {
      type: Boolean,
      default: true
    },
    filter: {
      // 是否可筛选
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'chengzi'
    },
    pageType: {
      type: Number
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    width() {
      return this.showAccount ? 1140 : 980
    },
    columns() {
      return this.type === 'asset' ? this.assetColumn : this.linkTableHead
    }
  },
  methods: {
    // 请求数据
    getData() {
      if (this.type === 'chengzi') {
        siteGetList({
          account: this.account,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          search: this.search
        }).then((data) => {
          this.show = true
          if (data) {
            this.linkDataList = data.list
            if (data.page_info) this.total = data.page_info.total_number
          }
        })
      } else if (this.type === 'kuaishou') {
        getMagneticPage({
          ad_account_id: this.account,
          page_type: this.pageType ? 1 : 2
        })
          .then((data) => {
            this.show = true
            this.linkDataList = data.map((ret) => {
              return {
                siteId: ret.id,
                name: ret.name,
                url: ret.url
              }
            })
          })
          .catch((err) => console.log(err))
      } else if (this.type === 'ptg') {
        getCaoHuaLinks({
          account: this.account,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          search: this.search
        }).then((data) => {
          this.show = true
          if (data) {
            this.linkDataList = data.list
            if (data.page_info) this.total = data.page_info.total_number
          }
        })
      } else if (this.type === 'asset') {
        getAssetList({
          ad_account_id: this.account,
          page_id: this.pageIndex,
          page_size: this.pageSize,
          search: this.search,
          asset_type: 'THIRD_EXTERNAL'
        }).then((data) => {
          this.show = true
          if (data) {
            this.linkDataList = data.list.map((ret) => {
              return {
                siteId: ret.asset_id,
                name: ret.asset_name
              }
            })
            if (data.page_info) this.total = data.page_info.total_number
          }
        })
      }
    },
    bindGetData(val) {
      if (val) {
        this.account = this.accounts[0].id
        this.selectAccounts = this.accounts.map((ret) => {
          return {
            accountId: ret.id,
            accountName: ret.name
          }
        })
        this.show = null
        this.getData()
      } else {
        this.show = null
        this.currentRow = undefined
        this.search = ''
        this.pageIndex = 1
      }
    },
    changePageIndex(index) {
      this.show = null
      this.pageIndex = index
      this.getData()
    },
    // 选中当前项
    bindCurrentRow(currentRow) {
      this.currentRow = currentRow
      const idx = this.selectAccounts.findIndex((ret) => ret.accountId === this.account)
      this.$set(this.selectAccounts[idx], 'row', currentRow)
    },
    asyncSelect() {
      const noteverySelect = this.selectAccounts.some((ret) => !ret.row)
      if (noteverySelect) {
        this.$Message.warning(this.showAccount ? '还有账号未选择落地页' : '未选择落地页')
        return false
      } else this.$emit('on-select', this.selectAccounts)
    },
    // 切换账号
    selectAccount(item) {
      this.account = item.id
      this.pageIndex = 1
      this.search = ''
      this.show = null
      this.getData()
    },
    rowClassName(val) {
      const idx = this.selectAccounts.findIndex((ret) => ret.accountId === this.account)
      const curRow = this.selectAccounts[idx].row
      if (curRow && curRow.siteId && val.siteId === curRow.siteId) return 'ivu-table-row-highlight'
      else return ''
    },
    accountSelected(item) {
      const idx = this.selectAccounts.findIndex((ret) => ret.accountId === item.id)
      const cur = this.selectAccounts[idx]
      if (cur && cur.row) return true
      else return false
    },
    handleSearch() {
      this.show = null
      this.pageIndex = 1
      this.getData()
    }
  },
  data() {
    return {
      show: null, // 请求状态
      total: 0, // 分页信息
      pageIndex: 1,
      pageSize: 10,
      search: '',
      account: null,
      linkDataList: [],
      selectAccounts: [], // 已选
      linkTableHead: [
        {
          key: 'siteId',
          title: '落地页ID',
          width: 180
        },
        {
          key: 'name',
          title: '落地页名称',
          width: 170
        },
        {
          key: 'url',
          title: '落地页地址'
        },
        {
          key: 'thumbnail',
          title: '预览图',
          width: 90,
          render: (h, params) => {
            const url = params.row.url
            return h(
              'a',
              {
                attrs: {
                  href: url,
                  target: '_blank'
                }
              },
              '查看'
            )
          }
        }
      ],
      assetColumn: [
        {
          key: 'siteId',
          title: '落地页ID'
        },
        {
          key: 'name',
          title: '落地页名称'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.account-box {
  width: 23%;
  height: 440px;
  display: inline-block;
  margin-right: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #d5d5d5;

  .account-item {
    padding: 6px;
    background: #f8f8f8;
    height: 40px;
    cursor: pointer;
    border-bottom: 1px solid #d5d5d5;

    .selected {
      color: red;
    }
  }

  .active-account {
    background: #2d8cf0;
    color: #fff;
  }
}

.data-table {
  width: 75%;
  display: inline-block;
  overflow: hidden;

  ::v-deep .ivu-table {
    width: 100%;
  }

  .input {
    width: 280px;
    margin-bottom: 8px;
  }
}

.page-index {
  margin-top: 12px;
  text-align: right;
}

::v-deep .ivu-table-row-highlight td {
  background-color: #2d8cf0 !important;
  color: #fff;

  a {
    color: #fff;
  }
}

::v-deep .width-full {
  width: 100%;
}
</style>
